import React from "react";
import { Route, Link, withRouter } from "react-router-dom";
import { updateProjectDetails } from "../../util/project_api_util"
import LogoSpinner from "../../../../assets/images/landing/video-thumbnails/MA-logo-spinner-transparent.gif";
import ScrollArrows from "../scroll_arrows"

class InviteModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errors: [],
      all_invites: this.props.project?.invites
        ? this.props.project.invites.split(",").filter(Boolean)
        : [],
      new_email: "",
      loading: false
    }
    this.handleInput = this.handleInput.bind(this)
    this.submitInvites = this.submitInvites.bind(this)
    this.validateEmail = this.validateEmail.bind(this)
    this.addEmail = this.addEmail.bind(this)
    this.deleteEmail = this.deleteEmail.bind(this)
    this.emailListRef = React.createRef()
  }

  componentDidMount() {
    document.body.style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.body.style.overflow = 'unset';
  }

  handleInput(field) {
    return e => this.setState({ [field]: e.target.value });
  }

  validateEmail(email) {
    const re = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return re.test(email);
  }

  addEmail(email){
    let all_invites = this.state.all_invites
    all_invites.push(email)
    this.setState({all_invites: all_invites, new_email: ""})
  }

  deleteEmail(index){
    let new_emails = this.state.all_invites
    new_emails.splice(index, 1)
    this.setState({ all_invites: new_emails })
  }

  submitInvites() {
    let data = {}
    let email_array = this.state.all_invites.map(email => email.trim()).filter(email => email !== '')
    let error = ""

    email_array.forEach(email => {
      if (!this.validateEmail(email)) {
        error = "One or more emails are invalid"
      }
    })

    if (error != "") {
      this.props.showToast(error)
    } else {
      data = { id: this.props.project.id, project: { id: this.props.project.id, invites: email_array.join(",") } }
      this.setState({loading: true})
      updateProjectDetails(data).then(() => {
        this.props.onClose()
        this.props.onReloadProject()
      })
    }
  }
  

  render() {
    let emailsLi = this.state.all_invites.map((email, i) => {
      return <div className="contractorServiceItem">
        <div className="itemTitleEmails" key={i}>{email}</div>
        <div className="" onClick={() => { this.deleteEmail(i) }}><i className="far fa-trash-alt settingsServiceIcon m-2"></i></div>
      </div>
    })

    return (
      <div className="modal-background" onClick={() => this.props.onClose()}>
        <div className="orderpreviewModal" onClick={e => e.stopPropagation()}>
          <div className="orderPreviewModalComponent">
            <div className="uploadPhotoModalHeadingGroup">
              <div className="uploadPhotoModalHeading">Project Invites</div>
              <div className="closeIcon" onClick={() => this.props.onClose()}><i className="fas fa-times"></i></div>
            </div>
            <div>
              Submit a list of all invites that should be included in the calendar events.
            </div>
            <div className="settingsCategoryGroup1">
              <div style={{ position: "relative" }}>
              <div className="emailList" ref={this.emailListRef}>
                {emailsLi}
              </div>
              <ScrollArrows scrollRef={this.emailListRef} />
              </div>
              <div className="settingsServicesInput">
                <input className="formInput shareMediaFormInput inviteModalEmails" onChange={this.handleInput("new_email")} type="text" placeholder="Add email" value={this.state.new_email} />
                <button onClick={() => this.addEmail(this.state.new_email)} className="addContractorServiceButton">Invite</button>
              </div>
            </div>
            <div className="reviewModalSubmitButton">
              {this.state.loading === false ? <button onClick={this.submitInvites} className="settingsButton">Submit</button> : <div className="MapLogoSpinner">
                <img className="contractorCalendarLogoImageSpinnerGif" src={LogoSpinner}></img>
              </div>}
            </div>
          </div>
          <div className="modalMobilePushup"></div>
        </div>
      </div>
    )
  }
}

export default withRouter(InviteModal);